export default "__VITE_ASSET__BIiJCVMz__"